import React from 'react';
import Moment from 'react-moment';

export function FormattedDate(props)
{
    const format = props.format || "MM/DD/YYYY";
    return <Moment format={format}>{props.date}</Moment>;
}

export function FormattedDateTime(props)
{
    return <Moment format="MM/DD/YYYY h:mm A">{props.date}</Moment>;
}